import { Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { noticeToCreditorsFlow } from "../index";
import * as Yup from "yup";
import { Formik, FormikHelpers } from "formik";
import { OUTCOMES, SCREEN_PATHS } from "../../../constants";
import { ScreenFlowFormButtons } from "../shared/ScreenFlowFormButtons";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";

interface Values {
  estateAddress: string;
}

export const EstateAddressScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const currentScreen = noticeToCreditorsFlow.getCurrentFlowScreen(screenName);

  // https://formik.org/docs/api/formik
  const formikInit = {
    values: {
      estateAddress: "",
    },
    schema: Yup.object().shape({
      estateAddress: Yup.string().required(),
    }),
  };

  const handleSubmit = async (
    values: Values,
    { setSubmitting, setStatus }: FormikHelpers<Values>
  ) => {
    setStatus("");
    try {
      if (!currentScreen) throw Error("couldn't determine currentScreen");

      // TODO: save to database

      noticeToCreditorsFlow.navigateToNext(
        currentScreen,
        OUTCOMES.complete,
        navigate
      );
    } catch (error) {
      setStatus("Sorry, error: " + ((error as Error)?.message || ""));
      // console.error(error);
      setSubmitting(false);
    }
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title="Where did [Jacob] live?"
      subTitle="This is typically the primary residence of the estate, or their last known address."
    >
      <Formik
        initialValues={formikInit.values}
        validationSchema={formikInit.schema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
          status,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={1}
              sx={{
                my: 1,
              }}
            >
              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.estateAddress && errors.estateAddress)}
                  fullWidth
                  helperText={touched.estateAddress && errors.estateAddress}
                  label="Address"
                  margin="normal"
                  name="estateAddress"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="text"
                  value={values.estateAddress}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <Link
                  to={`${SCREEN_PATHS.flow}/${noticeToCreditorsFlow.flowPath}/estate-address-unknown`}
                  style={{ textDecoration: "none" }}
                >
                  <Typography variant="body1">
                    I don’t know the address
                  </Typography>
                </Link>
              </Grid>
              <Grid item xs={12}>
                <ScreenFlowFormButtons
                  isSubmitting={isSubmitting}
                  status={status}
                  onBack={() => navigate(-1)}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
